import { useCallback, useMemo } from 'react';
import { prop } from 'ramda';

import { useAppSelector } from '@core/js/store/hooks';

import { useDataFetchWithAwait } from '@interlayer/js/app/hooks/useDataFetchWithAwait';

import { sortBingoSchedule } from './helpers';
import { getBingoSchedule } from './server';
import {
    TBingoGameSchedule,
    TGetBingoScheduleResponse,
    TGetSiteSchedulesProps,
    TUseGetBingoScheduleProps
} from './types';

export const useGetBingoSchedule = ({ lobbyName }: TUseGetBingoScheduleProps) => {
    const casinoName = useAppSelector(prop('casinoName'));

    const onResponse = useCallback((response: TGetBingoScheduleResponse): TBingoGameSchedule[] => {
        return sortBingoSchedule(response);
    }, []);

    const params: TGetSiteSchedulesProps = useMemo(() => ({
        lobbyName,
        casino: casinoName
    }), [casinoName, lobbyName]);

    return useDataFetchWithAwait({
        params,
        onResponse,
        initFetch: Boolean(lobbyName),
        fetch: getBingoSchedule
    });
};

